<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-main">
        <div class="footer-left">
          <img class="footer-logo" src="/img/swiss.png" alt="Swiss Money" title="Swiss Money">
          <h4 class="footer-heading">Contato</h4>
          <a href="https://t.me/SuporteSwissMoney" target="_blank" rel="noopener noreferrer" class="telegram-btn">
            <img src="/img/telegram.png" alt="Telegram" class="telegram-icon">
            TELEGRAM SUPORTE
          </a>
        </div>

        <div class="footer-center">
          <div class="club-swiss-box">
            <img src="/img/club-swiss.jpg" alt="Club Swiss" class="club-swiss-logo">
          </div>
          <p class="footer-description">Comunidade únida: faça parte de um grupo que compartilha experiências e conquistas.</p>
          <div class="footer-legal-links">
            <button type="button" class="footer-terms-link" @click="showTerms = true">Termos de Uso</button>
            <span class="footer-legal-sep">·</span>
            <button type="button" class="footer-terms-link" @click="showPrivacy = true">Política de Privacidade</button>
            <span class="footer-legal-sep">·</span>
            <button type="button" class="footer-terms-link" @click="showCookies = true">Política de Cookies</button>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <p class="footer-copyright">
          © 2026 Swiss Money. Todos os direitos reservados.
        </p>
      </div>
    </div>

    <section v-if="showTerms" class="modal terms-modal" @click.self="showTerms = false">
      <div class="box terms-box">
        <div class="header">
          <div class="title">Termos de Uso</div>
          <div class="close" @click="showTerms = false"><i class="fas fa-times"></i></div>
        </div>
        <div class="terms-content">
          <h3 class="terms-main-title">Termos de Uso do site</h3>

          <h4>1. Termos</h4>
          <p>Ao acessar ao site SWISS MONEY, concorda em cumprir estes termos de serviço, todas as leis e regulamentos aplicáveis e concorda que é responsável pelo cumprimento de todas as leis locais aplicáveis. Se você não concordar com algum desses termos, está proibido de usar ou acessar este site. Os materiais contidos neste site são protegidos pelas leis de direitos autorais e marcas comerciais aplicáveis.</p>

          <h4>2. Uso de Licença</h4>
          <p>É concedida permissão para baixar temporariamente uma cópia dos materiais (informações ou software) no site SWISS MONEY, apenas para visualização transitória pessoal e não comercial. Esta é a concessão de uma licença, não uma transferência de título e, sob esta licença, você não pode:</p>
          <ul>
            <li>2.1. modificar ou copiar os materiais;</li>
            <li>2.2. usar os materiais para qualquer finalidade comercial ou para exibição pública (comercial ou não comercial);</li>
            <li>2.3. tentar descompilar ou fazer engenharia reversa de qualquer software contido no site SWISS MONEY;</li>
            <li>2.4. remover quaisquer direitos autorais ou outras notações de propriedade dos materiais; ou</li>
            <li>2.5. transferir os materiais para outra pessoa ou 'espelhe' os materiais em qualquer outro servidor.</li>
          </ul>
          <p>Esta licença será automaticamente rescindida se você violar alguma dessas restrições e poderá ser rescindida por SWISS MONEY a qualquer momento. Ao encerrar a visualização desses materiais ou após o término desta licença, você deve apagar todos os materiais baixados em sua posse, seja em formato eletrônico ou impresso.</p>

          <h4>3. Isenção de responsabilidade</h4>
          <p>3.1. Os materiais no site da SWISS MONEY são fornecidos 'como estão'. SWISS MONEY não oferece garantias, expressas ou implícitas, e, por este meio, isenta e nega todas as outras garantias, incluindo, sem limitação, garantias implícitas ou condições de comercialização, adequação a um fim específico ou não violação de propriedade intelectual ou outra violação de direitos.</p>
          <p>3.2. Além disso, o SWISS MONEY não garante ou faz qualquer representação relativa à precisão, aos resultados prováveis ou à confiabilidade do uso dos materiais em seu site ou de outra forma relacionado a esses materiais ou em sites vinculados a este site.</p>

          <h4>4. Limitações</h4>
          <p>Em nenhum caso o SWISS MONEY ou seus fornecedores serão responsáveis por quaisquer danos (incluindo, sem limitação, danos por perda de dados ou lucro ou devido a interrupção dos negócios) decorrentes do uso ou da incapacidade de usar os materiais em SWISS MONEY, mesmo que SWISS MONEY ou um representante autorizado da SWISS MONEY tenha sido notificado oralmente ou por escrito da possibilidade de tais danos. Como algumas jurisdições não permitem limitações em garantias implícitas, ou limitações de responsabilidade por danos conseqüentes ou incidentais, essas limitações podem não se aplicar a você.</p>

          <h4>5. Precisão dos materiais</h4>
          <p>Os materiais exibidos no site da SWISS MONEY podem incluir erros técnicos, tipográficos ou fotográficos. SWISS MONEY não garante que qualquer material em seu site seja preciso, completo ou atual. SWISS MONEY pode fazer alterações nos materiais contidos em seu site a qualquer momento, sem aviso prévio. No entanto, SWISS MONEY não se compromete a atualizar os materiais.</p>

          <h4>6. Links</h4>
          <p>A SWISS MONEY não analisou todos os sites vinculados ao seu site e não é responsável pelo conteúdo de nenhum site vinculado. A inclusão de qualquer link não implica endosso por parte da SWISS MONEY ao site. O uso de qualquer site vinculado é por conta e risco do usuário.</p>
          <p>Nenhum usuário está autorizado a compartilhar links de terceiros, sobre a penalização de ser excluído da comunidade.</p>

          <h4>Modificações</h4>
          <p>A SWISS MONEY pode revisar estes termos de serviço do site a qualquer momento, sem aviso prévio. Ao usar este site, você concorda em ficar vinculado à versão atual desses termos de serviço.</p>

          <h4>Lei aplicável</h4>
          <p>Estes termos e condições são regidos e interpretados de acordo com as leis do SWISS MONEY e você se submete irrevogavelmente à jurisdição exclusiva dos tribunais naquele estado ou localidade.</p>
        </div>
      </div>
    </section>

    <section v-if="showPrivacy" class="modal terms-modal" @click.self="showPrivacy = false">
      <div class="box terms-box">
        <div class="header">
          <div class="title">Política de Privacidade</div>
          <div class="close" @click="showPrivacy = false"><i class="fas fa-times"></i></div>
        </div>
        <div class="terms-content">
          <h3 class="terms-main-title">Política de Privacidade do Site</h3>

          <p>A sua privacidade é importante para nós. É política do SWISS MONEY respeitar a sua privacidade em relação a qualquer informação sua que possamos coletar no site SWISS MONEY, e outros sites que possuímos e operamos.</p>

          <p>Solicitamos informações pessoais apenas quando realmente precisamos delas para lhe fornecer um serviço. Fazemo-lo por meios justos e legais, com o seu conhecimento e consentimento. Também informamos por que estamos coletando e como será usado.</p>

          <p>Apenas retemos as informações coletadas pelo tempo necessário para fornecer o serviço solicitado. Quando armazenamos dados, protegemos dentro de meios comercialmente aceitáveis para evitar perdas e roubos, bem como acesso, divulgação, cópia, uso ou modificação não autorizados.</p>

          <p>Não compartilhamos informações de identificação pessoal publicamente ou com terceiros, exceto quando exigido por lei. O nosso site pode ter links para sites externos que não são operados por nós. Esteja ciente de que não temos controle sobre o conteúdo e práticas desses sites e não podemos aceitar responsabilidade por suas respectivas políticas de privacidade.</p>

          <p>Você é livre para recusar a nossa solicitação de informações pessoais, entendendo que talvez não possamos fornecer alguns dos serviços desejados.</p>

          <p>O uso continuado de nosso site será considerado como aceitação de nossas práticas em torno de privacidade e informações pessoais. Se você tiver alguma dúvida sobre como lidamos com dados do usuário e informações pessoais, entre em contato conosco.</p>
        </div>
      </div>
    </section>

    <section v-if="showCookies" class="modal terms-modal" @click.self="showCookies = false">
      <div class="box terms-box">
        <div class="header">
          <div class="title">Política de Cookies</div>
          <div class="close" @click="showCookies = false"><i class="fas fa-times"></i></div>
        </div>
        <div class="terms-content">
          <h3 class="terms-main-title">Política de Cookies do site</h3>

          <h4>O que são cookies?</h4>
          <p>Como é prática comum em quase todos os sites profissionais, este site usa cookies, que são pequenos arquivos baixados no seu computador, para melhorar sua experiência. Esta página descreve quais informações eles coletam, como as usamos e por que às vezes precisamos armazenar esses cookies. Também compartilharemos como você pode impedir que esses cookies sejam armazenados, no entanto, isso pode fazer o downgrade ou 'quebrar' certos elementos da funcionalidade do site.</p>

          <h4>Como usamos os cookies?</h4>
          <p>Utilizamos cookies por vários motivos, detalhados abaixo. Infelizmente, na maioria dos casos, não existem opções padrão do setor para desativar os cookies sem desativar completamente a funcionalidade e os recursos que eles adicionam a este site. É recomendável que você deixe todos os cookies se não tiver certeza se precisa ou não deles, caso sejam usados para fornecer um serviço que você usa.</p>

          <h4>Desativar cookies</h4>
          <p>Você pode impedir a configuração de cookies ajustando as configurações do seu navegador (consulte a Ajuda do navegador para saber como fazer isso). Esteja ciente de que a desativação de cookies afetará a funcionalidade deste e de muitos outros sites que você visita. A desativação de cookies geralmente resultará na desativação de determinadas funcionalidades e recursos deste site. Portanto, é recomendável que você não desative os cookies.</p>

          <h4>Cookies que definimos</h4>
          <ul>
            <li><strong>Cookies relacionados à conta</strong> — Se você criar uma conta conosco, usaremos cookies para o gerenciamento do processo de inscrição e administração geral. Esses cookies geralmente serão excluídos quando você sair do sistema, porém, em alguns casos, eles poderão permanecer posteriormente para lembrar as preferências do seu site ao sair.</li>
            <li><strong>Cookies relacionados ao login</strong> — Utilizamos cookies quando você está logado, para que possamos lembrar dessa ação. Isso evita que você precise fazer login sempre que visitar uma nova página. Esses cookies são normalmente removidos ou limpos quando você efetua logout para garantir que você possa acessar apenas a recursos e áreas restritas ao efetuar login.</li>
            <li><strong>Cookies relacionados a boletins por e-mail</strong> — Este site oferece serviços de assinatura de boletim informativo ou e-mail e os cookies podem ser usados para lembrar se você já está registrado e se deve mostrar determinadas notificações válidas apenas para usuários inscritos / não inscritos.</li>
            <li><strong>Pedidos processando cookies relacionados</strong> — Este site oferece facilidades de comércio eletrônico ou pagamento e alguns cookies são essenciais para garantir que seu pedido seja lembrado entre as páginas, para que possamos processá-lo adequadamente.</li>
            <li><strong>Cookies relacionados a pesquisas</strong> — Periodicamente, oferecemos pesquisas e questionários para fornecer informações interessantes, ferramentas úteis ou para entender nossa base de usuários com mais precisão. Essas pesquisas podem usar cookies para lembrar quem já participou numa pesquisa ou para fornecer resultados precisos após a alteração das páginas.</li>
            <li><strong>Cookies relacionados a formulários</strong> — Quando você envia dados por meio de um formulário como os encontrados nas páginas de contacto ou nos formulários de comentários, os cookies podem ser configurados para lembrar os detalhes do usuário para correspondência futura.</li>
            <li><strong>Cookies de preferências do site</strong> — Para proporcionar uma ótima experiência neste site, fornecemos a funcionalidade para definir suas preferências de como esse site é executado quando você o usa. Para lembrar suas preferências, precisamos definir cookies para que essas informações possam ser chamadas sempre que você interagir com uma página for afetada por suas preferências.</li>
          </ul>

          <h4>Cookies de Terceiros</h4>
          <p>Em alguns casos especiais, também usamos cookies fornecidos por terceiros confiáveis. A seção a seguir detalha quais cookies de terceiros você pode encontrar através deste site.</p>
          <ul>
            <li>Este site usa o Google Analytics, que é uma das soluções de análise mais difundidas e confiáveis da Web, para nos ajudar a entender como você usa o site e como podemos melhorar sua experiência. Esses cookies podem rastrear itens como quanto tempo você gasta no site e as páginas visitadas, para que possamos continuar produzindo conteúdo atraente.</li>
          </ul>
          <p>Para mais informações sobre cookies do Google Analytics, consulte a página oficial do Google Analytics.</p>
          <ul>
            <li>As análises de terceiros são usadas para rastrear e medir o uso deste site, para que possamos continuar produzindo conteúdo atrativo. Esses cookies podem rastrear itens como o tempo que você passa no site ou as páginas visitadas, o que nos ajuda a entender como podemos melhorar o site para você.</li>
            <li>Periodicamente, testamos novos recursos e fazemos alterações subtis na maneira como o site se apresenta. Quando ainda estamos testando novos recursos, esses cookies podem ser usados para garantir que você receba uma experiência consistente enquanto estiver no site, enquanto entendemos quais otimizações os nossos usuários mais apreciam.</li>
            <li>À medida que vendemos produtos, é importante entendermos as estatísticas sobre quantos visitantes de nosso site realmente compram e, portanto, esse é o tipo de dados que esses cookies rastrearão. Isso é importante para você, pois significa que podemos fazer previsões de negócios com precisão que nos permitem analisar nossos custos de publicidade e produtos para garantir o melhor preço possível.</li>
          </ul>

          <h4>Compromisso do Usuário</h4>
          <p>O usuário se compromete a fazer uso adequado dos conteúdos e da informação que o SWISS MONEY oferece no site e com caráter enunciativo, mas não limitativo:</p>
          <ul>
            <li>A) Não se envolver em atividades que sejam ilegais ou contrárias à boa fé a à ordem pública;</li>
            <li>B) Não difundir propaganda ou conteúdo de natureza racista, xenofóbica, Onde Bola ou azar, qualquer tipo de pornografia ilegal, de apologia ao terrorismo ou contra os direitos humanos;</li>
            <li>C) Não causar danos aos sistemas físicos (hardwares) e lógicos (softwares) do SWISS MONEY, de seus fornecedores ou terceiros, para introduzir ou disseminar vírus informáticos ou quaisquer outros sistemas de hardware ou software que sejam capazes de causar danos anteriormente mencionados.</li>
          </ul>

          <h4>Mais informações</h4>
          <p>Esperamos que esteja esclarecido e, como mencionado anteriormente, se houver algo que você não tem certeza se precisa ou não, geralmente é mais seguro deixar os cookies ativados, caso interaja com um dos recursos que você usa em nosso site. Esta política é efetiva a partir de Junho/2026.</p>
        </div>
      </div>
    </section>

    <div class="alerta-fixed">
      <img src="/img/alertanvh-golpe.png" alt="Alerta de Golpe" class="alerta-image">
    </div>
  </footer>
</template>

<script>

export default {
  name: 'footerComponent',
  data () {
    return {
      showTerms: false,
      showPrivacy: false,
      showCookies: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables.scss";

.footer {
  background: #000;
  color: #fff;
  padding: 60px 0 30px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-main {
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid #333;
}

.footer-left {
  .footer-logo {
    height: 45px;
    width: auto;
    margin-bottom: 25px;
  }

  .footer-heading {
    font-size: 16px;
    font-weight: 600;
    color: #fff;
    margin: 0 0 15px 0;
  }

  .telegram-btn {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 12px 24px;
    background: #0088cc;
    color: #fff;
    text-decoration: none;
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
    border-radius: 8px;
    transition: opacity 0.3s;

    &:hover {
      opacity: 0.9;
    }

    .telegram-icon {
      height: 24px;
      width: auto;
    }
  }
}

.footer-center {
  .club-swiss-box {
    margin-bottom: 20px;
  }

  .club-swiss-logo {
    max-width: 200px;
    height: auto;
  }

  .footer-description {
    font-size: 15px;
    color: #fff;
    line-height: 1.6;
    margin: 0;
  }
}

.alerta-fixed {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 90;
  max-width: 140px;
  pointer-events: none;

  .alerta-image {
    width: 100%;
    height: auto;
    display: block;
    filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.45));
  }
}

.footer-bottom {
  padding-top: 30px;
  text-align: center;
}

.footer-copyright {
  font-size: 14px;
  color: #888;
  margin: 0;
}

.footer-legal-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
}

.footer-legal-sep {
  color: #555;
  font-size: 14px;
  user-select: none;
}

.footer-terms-link {
  display: inline-block;
  margin-left: 0;
  padding: 0;
  border: none;
  background: none;
  color: #aaa;
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #fff;
  }
}

.terms-modal ::v-deep .terms-box {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

.terms-content {
  flex: 1;
  overflow-y: auto;
  padding: 0 20px 24px;
  color: #ccc;
  font-size: 14px;
  line-height: 1.65;

  .terms-main-title {
    margin: 0 0 20px;
    font-size: 18px;
    font-weight: 600;
    color: #fff;
  }

  h4 {
    margin: 20px 0 8px;
    font-size: 15px;
    font-weight: 600;
    color: #fff;
  }

  p {
    margin: 0 0 12px;
  }

  ul {
    margin: 0 0 12px;
    padding-left: 20px;

    li {
      margin-bottom: 6px;

      strong {
        color: #e8e8e8;
      }
    }
  }
}

@media screen and (min-width: $desktop-width) {
  .terms-modal ::v-deep .terms-box {
    max-width: 720px;
    width: 100%;
  }
}

// Desktop
@media screen and (min-width: $desktop-width) {
  .footer-main {
    grid-template-columns: auto 1fr;
    align-items: start;
    gap: 60px;
  }

  .alerta-fixed {
    right: 24px;
    bottom: 24px;
    max-width: 220px;
  }
}

// Print
@media print {
  .footer {
    display: none;
  }

  .alerta-fixed {
    display: none;
  }
}
</style>
